<template>
  <div class="request-contact-info-main-section mt-4">
    <section-title
      content="Información adicional a ser considerada"
      :has-line="true"
    />
    <div class="p-4 bg-light-gray rounded">
      <span v-if="isReadOnly" class="data-content d-block">
        {{ model | empty }}
      </span>
      <ValidationProvider  v-else v-slot="{ errors }" rules="required">
        <custom-text-area
          v-model="model"
          :count-classes="['float-right']"
          :maxlength="3000"
          show-char-count
          :error="errors[0]"
          custom-error-msg="Favor registrar un comentario."
        />
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';
export default {
  name: 'RequestAdditionalInfo',
  components: {
    SectionTitle,
    CustomTextArea,
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
